
import Vue from 'vue'
export default Vue.extend({
  name: 'TextInput',
  props: {
    id: {
      type: String,
      default: '',
      required: false,
    },
    placeholder: {
      type: String,
      default: '',
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    defaultValue: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      value: this.$props.defaultValue,
      textInputClass: {
        'form-error': false,
      },
    }
  },
  methods: {
    isEmpty() {
      // eslint-disable-next-line no-unused-expressions
      this.required ? (this.textInputClass['form-error'] = this.value.length <= 0) : false
    },
  },
})
